export const userStatusList = ['Enabled', 'Disabled', 'Expired'] as const;
export type UserStatus = (typeof userStatusList)[number];

export const userStatusValue = {
    ENABLED: 'enabled',
    DISABLED: 'disabled',
    EXPIRED: 'expired',
} as const satisfies Record<Uppercase<UserStatus>, Lowercase<UserStatus>>;

export type UserStatusValue = (typeof userStatusValue)[keyof typeof userStatusValue];

export type UserType = 'Internal' | 'External';

export const userBulkAction = {
    ENABLED: 'enabled',
    DISABLED: 'disabled',
    EMAILED: 'emailed',
    UNLOCKED: 'unlocked',
} as const;

export type UserBulkAction = (typeof userBulkAction)[keyof typeof userBulkAction];
